import { title as titleCase } from 'case';
import React from 'react';

import { Chip, useTheme } from '@/components/ui';
import { TaskStatus } from '@/types/models';

const STATUS_COLORS: Record<string, { bg: string; text: string }> = {
	[TaskStatus.Open]: { bg: '#e3f2fd', text: '#1565c0' },
	[TaskStatus.InProgress]: { bg: '#fff3e0', text: '#e65100' },
	[TaskStatus.Completed]: { bg: '#e8f5e9', text: '#2e7d32' },
	[TaskStatus.Cancelled]: { bg: '#fafafa', text: '#757575' },
	[TaskStatus.Archived]: { bg: '#fce4ec', text: '#ad1457' },
};

export const TaskStatusBadge: React.FC<{ status: string }> = ({ status }) => {
	const theme = useTheme();
	const colors = STATUS_COLORS[status] || { bg: theme.colors.surfaceVariant, text: theme.colors.onSurface };
	return (
		<Chip
			mode="flat"
			style={{ backgroundColor: colors.bg, borderRadius: 12 }}
			textStyle={{ color: colors.text, fontSize: 12 }}
		>
			{titleCase(status)}
		</Chip>
	);
};
